"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchInitPreprocessor = void 0;
/**
 * Does nothing in browsers
 */
class FetchInitPreprocessor {
    handle(init) {
        // Remove overridden user-agent header within browsers to avoid CORS issues
        if (init.headers) {
            const headers = new Headers(init.headers);
            if (headers.has('user-agent')) {
                headers.delete('user-agent');
            }
            init.headers = headers;
        }
        return Object.assign({ keepalive: true }, init);
    }
}
exports.FetchInitPreprocessor = FetchInitPreprocessor;
//# sourceMappingURL=FetchInitPreprocessor-browser.js.map